/**
 * Rôle : Container principal
 * Copyright: © 2021 Remote Monkey S.A.S.U http://remote-monkey.fr
 */
import React from 'react';

export default function ContentLeft(props) {
	const { children, backgroundDisplay } = props;

	let background, padding;

	if (backgroundDisplay === false) {
		background = 'bg-none';
		padding = 'pr-5';
	} else {
		background = 'bg-gray-100';
		padding = 'p-10';
	}

	return <div className={`${background} pr-0 md:${padding} w-full lg:mb-0 mb-0`}>{children}</div>;
}
